import { combineReducers } from "redux";

// Front
import Layout from "./layout/reducer";

// Authentication
import Profile from "./auth/profile/reducer";

//E-commerce
import ecommerce from "./e-commerce/reducer";


//invoices
import invoices from "./invoices/reducer";

//Dashboard 
import Dashboard from "./dashboard/reducer";

import addRole from './Role/reducer'


const rootReducer = combineReducers({
  // public
  Layout,
  Profile,
  ecommerce,
  invoices,
  Dashboard,
  addRole,
});

export default rootReducer;
